<template>
  <v-row
    dense
  >
    <v-col cols="12" sm="6">
      <v-text-field
        dense
        outlined
        v-model="firstName"
        :rules="[rules.required, rules.alphanumeric]"
        label="First Name"
        autocomplete="given-name"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="6">
      <v-text-field
        dense
        outlined
        v-model="lastName"
        :rules="[rules.required, rules.alphanumeric]"
        label="Last Name"
        autocomplete="family-name"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="6" v-if="!defaultEmail">
      <v-text-field
        dense
        outlined
        :disabled="emailDisabled"
        v-model="email"
        :rules="[rules.required, rules.email]"
        label="Email"
        autocomplete="email"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="6">
      <v-text-field
        dense
        outlined
        v-model="companyName"
        :rules="[]"
        label="Company Name"
        autocomplete="organization"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="12">
      <v-text-field
        dense
        outlined
        v-model="address1"
        :rules="[rules.required]"
        label="Address1"
        autocomplete="address-line1"
      ></v-text-field>
    </v-col>
<!--    <v-col cols="12" sm="12">-->
<!--      <v-text-field-->
<!--        dense-->
<!--        outlined-->
<!--        v-model="address2"-->
<!--        :rules="[]"-->
<!--        label="Address2"-->
<!--        autocomplete="address-line2"-->
<!--      ></v-text-field>-->
<!--    </v-col>-->
    <v-col cols="12" sm="6" v-if="country != 'SG'">
      <v-text-field
        dense
        outlined
        v-model="city"
        :rules="[rules.required]"
        label="city"
        autocompelete="city"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="6" v-if="country != 'SG'">
      <v-text-field
        dense
        outlined
        v-model="state"
        :rules="[rules.required]"
        label="State"
        autocompelete="state"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="6">
      <v-autocomplete
        dense
        outlined
        v-model="country"
        :disabled="countryDisabled"
        :rules="[rules.required]"
        :items="countries"
        label="Country"
        placeholder="Select..."
        autocomplete="off"
      ></v-autocomplete>
    </v-col>
    <v-col cols="12" sm="6">
      <v-text-field
        dense
        outlined
        v-model="postalCode"
        :rules="[rules.required, rules.postalcode]"
        label="Postal Code"
        autocompelete="postal_code"
      ></v-text-field>
    </v-col>
    <v-col cols="6">
      <v-autocomplete
        dense
        outlined
        v-model="phoneCountryCode"
        :rules="[rules.required]"
        :items="phoneCountryCodes"
        label="Phone Country Code"
        placeholder="Select..."
        autocomplete="tel-country-code"
      ></v-autocomplete>
    </v-col>
    <v-col cols="6">
      <v-text-field
        dense
        outlined
        v-model="phone"
        :rules="[rules.required, rules.phone]"
        label="Phone Number"
        autocomplete="tel-national"
      ></v-text-field>
    </v-col>
<!--    <v-col cols="6">-->
<!--      <v-autocomplete-->
<!--        dense-->
<!--        outlined-->
<!--        v-model="faxCountryCode"-->
<!--        :rules="[]"-->
<!--        :items="phoneCountryCodes"-->
<!--        label="Fax Country Code"-->
<!--        placeholder="Select..."-->
<!--        autocomplete="off"-->
<!--      ></v-autocomplete>-->
<!--    </v-col>-->
<!--    <v-col cols="6">-->
<!--      <v-text-field-->
<!--        dense-->
<!--        outlined-->
<!--        v-model="fax"-->
<!--        :rules="[rules.fax]"-->
<!--        label="Fax Number"-->
<!--        autocomplete="off"-->
<!--      ></v-text-field>-->
<!--    </v-col>-->
  </v-row>
</template>

<script>
// import PhoneNumber from 'awesome-phonenumber';

export default {
  name: 'Profile',
  data() {
    return {
      emailDisabled: false,
      countryDisabled: false,
      firstName: '',
      lastName: '',
      email: '',
      companyName: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      country: 'SG',
      postalCode: '',
      phoneCountryCode: 65,
      phone: '',
      faxCountryCode: '',
      fax: '',
      rules: {
        required: (value) => (value !== 0 && !!`${value}`.trim()) || 'Required.',
        alphanumeric: (value) => {
          const pattern = /^[a-zA-Z0-9 ]+$/;
          return pattern.test(value) || 'Only a-z,A-Z,0-9 and space are allowed.';
        },
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Invalid e-mail.';
        },
        phone: (value) => {
          const pattern = /^[0-9]{4,13}$/;
          return pattern.test(value) || 'Invalid phone, only support 4-13 digits.';
        },
        fax: (value) => {
          const pattern = /^([0-9]{4,12})?$/;
          if (value === null || value === '') {
            return true;
          }
          return pattern.test(value) || 'Invalid fax, only support 4-12 digits.';
        },
        postalcode: (value) => {
          const pattern = /^([a-zA-Z0-9]{1,16})?$/;
          return pattern.test(value) || 'Invalid postal code, only support max 16 characters.';
        },
      },
      countries: [
        {
          text: 'Afghanistan',
          value: 'AF',
        },
        {
          text: 'Åland Islands',
          value: 'AX',
        },
        {
          text: 'Albania',
          value: 'AL',
        },
        {
          text: 'Algeria',
          value: 'DZ',
        },
        {
          text: 'American Samoa',
          value: 'AS',
        },
        {
          text: 'Andorra',
          value: 'AD',
        },
        {
          text: 'Angola',
          value: 'AO',
        },
        {
          text: 'Anguilla',
          value: 'AI',
        },
        {
          text: 'Antarctica',
          value: 'AQ',
        },
        {
          text: 'Antigua and Barbuda',
          value: 'AG',
        },
        {
          text: 'Argentina',
          value: 'AR',
        },
        {
          text: 'Armenia',
          value: 'AM',
        },
        {
          text: 'Aruba',
          value: 'AW',
        },
        {
          text: 'Australia',
          value: 'AU',
        },
        {
          text: 'Austria',
          value: 'AT',
        },
        {
          text: 'Azerbaijan',
          value: 'AZ',
        },
        {
          text: 'Bahamas',
          value: 'BS',
        },
        {
          text: 'Bahrain',
          value: 'BH',
        },
        {
          text: 'Bangladesh',
          value: 'BD',
        },
        {
          text: 'Barbados',
          value: 'BB',
        },
        {
          text: 'Belarus',
          value: 'BY',
        },
        {
          text: 'Belgium',
          value: 'BE',
        },
        {
          text: 'Belize',
          value: 'BZ',
        },
        {
          text: 'Benin',
          value: 'BJ',
        },
        {
          text: 'Bermuda',
          value: 'BM',
        },
        {
          text: 'Bhutan',
          value: 'BT',
        },
        {
          text: 'Bolivia, Plurinational State of',
          value: 'BO',
        },
        {
          text: 'Bonaire, Sint Eustatius and Saba',
          value: 'BQ',
        },
        {
          text: 'Bosnia and Herzegovina',
          value: 'BA',
        },
        {
          text: 'Botswana',
          value: 'BW',
        },
        {
          text: 'Bouvet Island',
          value: 'BV',
        },
        {
          text: 'Brazil',
          value: 'BR',
        },
        {
          text: 'British Indian Ocean Territory',
          value: 'IO',
        },
        {
          text: 'Brunei Darussalam',
          value: 'BN',
        },
        {
          text: 'Bulgaria',
          value: 'BG',
        },
        {
          text: 'Burkina Faso',
          value: 'BF',
        },
        {
          text: 'Burundi',
          value: 'BI',
        },
        {
          text: 'Cambodia',
          value: 'KH',
        },
        {
          text: 'Cameroon',
          value: 'CM',
        },
        {
          text: 'Canada',
          value: 'CA',
        },
        {
          text: 'Cape Verde',
          value: 'CV',
        },
        {
          text: 'Cayman Islands',
          value: 'KY',
        },
        {
          text: 'Central African Republic',
          value: 'CF',
        },
        {
          text: 'Chad',
          value: 'TD',
        },
        {
          text: 'Chile',
          value: 'CL',
        },
        {
          text: 'China',
          value: 'CN',
        },
        {
          text: 'Christmas Island',
          value: 'CX',
        },
        {
          text: 'Cocos (Keeling) Islands',
          value: 'CC',
        },
        {
          text: 'Colombia',
          value: 'CO',
        },
        {
          text: 'Comoros',
          value: 'KM',
        },
        {
          text: 'Congo',
          value: 'CG',
        },
        {
          text: 'Congo, the Democratic Republic of the',
          value: 'CD',
        },
        {
          text: 'Cook Islands',
          value: 'CK',
        },
        {
          text: 'Costa Rica',
          value: 'CR',
        },
        {
          text: 'Côte d\'Ivoire',
          value: 'CI',
        },
        {
          text: 'Croatia',
          value: 'HR',
        },
        {
          text: 'Cuba',
          value: 'CU',
        },
        {
          text: 'Curaçao',
          value: 'CW',
        },
        {
          text: 'Cyprus',
          value: 'CY',
        },
        {
          text: 'Czech Republic',
          value: 'CZ',
        },
        {
          text: 'Denmark',
          value: 'DK',
        },
        {
          text: 'Djibouti',
          value: 'DJ',
        },
        {
          text: 'Dominica',
          value: 'DM',
        },
        {
          text: 'Dominican Republic',
          value: 'DO',
        },
        {
          text: 'Ecuador',
          value: 'EC',
        },
        {
          text: 'Egypt',
          value: 'EG',
        },
        {
          text: 'El Salvador',
          value: 'SV',
        },
        {
          text: 'Equatorial Guinea',
          value: 'GQ',
        },
        {
          text: 'Eritrea',
          value: 'ER',
        },
        {
          text: 'Estonia',
          value: 'EE',
        },
        {
          text: 'Ethiopia',
          value: 'ET',
        },
        {
          text: 'Falkland Islands (Malvinas)',
          value: 'FK',
        },
        {
          text: 'Faroe Islands',
          value: 'FO',
        },
        {
          text: 'Fiji',
          value: 'FJ',
        },
        {
          text: 'Finland',
          value: 'FI',
        },
        {
          text: 'France',
          value: 'FR',
        },
        {
          text: 'French Guiana',
          value: 'GF',
        },
        {
          text: 'French Polynesia',
          value: 'PF',
        },
        {
          text: 'French Southern Territories',
          value: 'TF',
        },
        {
          text: 'Gabon',
          value: 'GA',
        },
        {
          text: 'Gambia',
          value: 'GM',
        },
        {
          text: 'Georgia',
          value: 'GE',
        },
        {
          text: 'Germany',
          value: 'DE',
        },
        {
          text: 'Ghana',
          value: 'GH',
        },
        {
          text: 'Gibraltar',
          value: 'GI',
        },
        {
          text: 'Greece',
          value: 'GR',
        },
        {
          text: 'Greenland',
          value: 'GL',
        },
        {
          text: 'Grenada',
          value: 'GD',
        },
        {
          text: 'Guadeloupe',
          value: 'GP',
        },
        {
          text: 'Guam',
          value: 'GU',
        },
        {
          text: 'Guatemala',
          value: 'GT',
        },
        {
          text: 'Guernsey',
          value: 'GG',
        },
        {
          text: 'Guinea',
          value: 'GN',
        },
        {
          text: 'Guinea-Bissau',
          value: 'GW',
        },
        {
          text: 'Guyana',
          value: 'GY',
        },
        {
          text: 'Haiti',
          value: 'HT',
        },
        {
          text: 'Heard Island and McDonald Mcdonald Islands',
          value: 'HM',
        },
        {
          text: 'Holy See (Vatican City State)',
          value: 'VA',
        },
        {
          text: 'Honduras',
          value: 'HN',
        },
        {
          text: 'Hong Kong',
          value: 'HK',
        },
        {
          text: 'Hungary',
          value: 'HU',
        },
        {
          text: 'Iceland',
          value: 'IS',
        },
        {
          text: 'India',
          value: 'IN',
        },
        {
          text: 'Indonesia',
          value: 'ID',
        },
        {
          text: 'Iran, Islamic Republic of',
          value: 'IR',
        },
        {
          text: 'Iraq',
          value: 'IQ',
        },
        {
          text: 'Ireland',
          value: 'IE',
        },
        {
          text: 'Isle of Man',
          value: 'IM',
        },
        {
          text: 'Israel',
          value: 'IL',
        },
        {
          text: 'Italy',
          value: 'IT',
        },
        {
          text: 'Jamaica',
          value: 'JM',
        },
        {
          text: 'Japan',
          value: 'JP',
        },
        {
          text: 'Jersey',
          value: 'JE',
        },
        {
          text: 'Jordan',
          value: 'JO',
        },
        {
          text: 'Kazakhstan',
          value: 'KZ',
        },
        {
          text: 'Kenya',
          value: 'KE',
        },
        {
          text: 'Kiribati',
          value: 'KI',
        },
        {
          text: 'Korea, Democratic People\'s Republic of',
          value: 'KP',
        },
        {
          text: 'Korea, Republic of',
          value: 'KR',
        },
        {
          text: 'Kuwait',
          value: 'KW',
        },
        {
          text: 'Kyrgyzstan',
          value: 'KG',
        },
        {
          text: 'Lao People\'s Democratic Republic',
          value: 'LA',
        },
        {
          text: 'Latvia',
          value: 'LV',
        },
        {
          text: 'Lebanon',
          value: 'LB',
        },
        {
          text: 'Lesotho',
          value: 'LS',
        },
        {
          text: 'Liberia',
          value: 'LR',
        },
        {
          text: 'Libya',
          value: 'LY',
        },
        {
          text: 'Liechtenstein',
          value: 'LI',
        },
        {
          text: 'Lithuania',
          value: 'LT',
        },
        {
          text: 'Luxembourg',
          value: 'LU',
        },
        {
          text: 'Macao',
          value: 'MO',
        },
        {
          text: 'Macedonia, the Former Yugoslav Republic of',
          value: 'MK',
        },
        {
          text: 'Madagascar',
          value: 'MG',
        },
        {
          text: 'Malawi',
          value: 'MW',
        },
        {
          text: 'Malaysia',
          value: 'MY',
        },
        {
          text: 'Maldives',
          value: 'MV',
        },
        {
          text: 'Mali',
          value: 'ML',
        },
        {
          text: 'Malta',
          value: 'MT',
        },
        {
          text: 'Marshall Islands',
          value: 'MH',
        },
        {
          text: 'Martinique',
          value: 'MQ',
        },
        {
          text: 'Mauritania',
          value: 'MR',
        },
        {
          text: 'Mauritius',
          value: 'MU',
        },
        {
          text: 'Mayotte',
          value: 'YT',
        },
        {
          text: 'Mexico',
          value: 'MX',
        },
        {
          text: 'Micronesia, Federated States of',
          value: 'FM',
        },
        {
          text: 'Moldova, Republic of',
          value: 'MD',
        },
        {
          text: 'Monaco',
          value: 'MC',
        },
        {
          text: 'Mongolia',
          value: 'MN',
        },
        {
          text: 'Montenegro',
          value: 'ME',
        },
        {
          text: 'Montserrat',
          value: 'MS',
        },
        {
          text: 'Morocco',
          value: 'MA',
        },
        {
          text: 'Mozambique',
          value: 'MZ',
        },
        {
          text: 'Myanmar',
          value: 'MM',
        },
        {
          text: 'Namibia',
          value: 'NA',
        },
        {
          text: 'Nauru',
          value: 'NR',
        },
        {
          text: 'Nepal',
          value: 'NP',
        },
        {
          text: 'Netherlands',
          value: 'NL',
        },
        {
          text: 'New Caledonia',
          value: 'NC',
        },
        {
          text: 'New Zealand',
          value: 'NZ',
        },
        {
          text: 'Nicaragua',
          value: 'NI',
        },
        {
          text: 'Niger',
          value: 'NE',
        },
        {
          text: 'Nigeria',
          value: 'NG',
        },
        {
          text: 'Niue',
          value: 'NU',
        },
        {
          text: 'Norfolk Island',
          value: 'NF',
        },
        {
          text: 'Northern Mariana Islands',
          value: 'MP',
        },
        {
          text: 'Norway',
          value: 'NO',
        },
        {
          text: 'Oman',
          value: 'OM',
        },
        {
          text: 'Pakistan',
          value: 'PK',
        },
        {
          text: 'Palau',
          value: 'PW',
        },
        {
          text: 'Palestine, State of',
          value: 'PS',
        },
        {
          text: 'Panama',
          value: 'PA',
        },
        {
          text: 'Papua New Guinea',
          value: 'PG',
        },
        {
          text: 'Paraguay',
          value: 'PY',
        },
        {
          text: 'Peru',
          value: 'PE',
        },
        {
          text: 'Philippines',
          value: 'PH',
        },
        {
          text: 'Pitcairn',
          value: 'PN',
        },
        {
          text: 'Poland',
          value: 'PL',
        },
        {
          text: 'Portugal',
          value: 'PT',
        },
        {
          text: 'Puerto Rico',
          value: 'PR',
        },
        {
          text: 'Qatar',
          value: 'QA',
        },
        {
          text: 'Réunion',
          value: 'RE',
        },
        {
          text: 'Romania',
          value: 'RO',
        },
        {
          text: 'Russian Federation',
          value: 'RU',
        },
        {
          text: 'Rwanda',
          value: 'RW',
        },
        {
          text: 'Saint Barthélemy',
          value: 'BL',
        },
        {
          text: 'Saint Helena, Ascension and Tristan da Cunha',
          value: 'SH',
        },
        {
          text: 'Saint Kitts and Nevis',
          value: 'KN',
        },
        {
          text: 'Saint Lucia',
          value: 'LC',
        },
        {
          text: 'Saint Martin (French part)',
          value: 'MF',
        },
        {
          text: 'Saint Pierre and Miquelon',
          value: 'PM',
        },
        {
          text: 'Saint Vincent and the Grenadines',
          value: 'VC',
        },
        {
          text: 'Samoa',
          value: 'WS',
        },
        {
          text: 'San Marino',
          value: 'SM',
        },
        {
          text: 'Sao Tome and Principe',
          value: 'ST',
        },
        {
          text: 'Saudi Arabia',
          value: 'SA',
        },
        {
          text: 'Senegal',
          value: 'SN',
        },
        {
          text: 'Serbia',
          value: 'RS',
        },
        {
          text: 'Seychelles',
          value: 'SC',
        },
        {
          text: 'Sierra Leone',
          value: 'SL',
        },
        {
          text: 'Singapore',
          value: 'SG',
        },
        {
          text: 'Sint Maarten (Dutch part)',
          value: 'SX',
        },
        {
          text: 'Slovakia',
          value: 'SK',
        },
        {
          text: 'Slovenia',
          value: 'SI',
        },
        {
          text: 'Solomon Islands',
          value: 'SB',
        },
        {
          text: 'Somalia',
          value: 'SO',
        },
        {
          text: 'South Africa',
          value: 'ZA',
        },
        {
          text: 'South Georgia and the South Sandwich Islands',
          value: 'GS',
        },
        {
          text: 'South Sudan',
          value: 'SS',
        },
        {
          text: 'Spain',
          value: 'ES',
        },
        {
          text: 'Sri Lanka',
          value: 'LK',
        },
        {
          text: 'Sudan',
          value: 'SD',
        },
        {
          text: 'Suriname',
          value: 'SR',
        },
        {
          text: 'Svalbard and Jan Mayen',
          value: 'SJ',
        },
        {
          text: 'Swaziland',
          value: 'SZ',
        },
        {
          text: 'Sweden',
          value: 'SE',
        },
        {
          text: 'Switzerland',
          value: 'CH',
        },
        {
          text: 'Syrian Arab Republic',
          value: 'SY',
        },
        {
          text: 'Taiwan, Province of China',
          value: 'TW',
        },
        {
          text: 'Tajikistan',
          value: 'TJ',
        },
        {
          text: 'Tanzania, United Republic of',
          value: 'TZ',
        },
        {
          text: 'Thailand',
          value: 'TH',
        },
        {
          text: 'Timor-Leste',
          value: 'TL',
        },
        {
          text: 'Togo',
          value: 'TG',
        },
        {
          text: 'Tokelau',
          value: 'TK',
        },
        {
          text: 'Tonga',
          value: 'TO',
        },
        {
          text: 'Trinidad and Tobago',
          value: 'TT',
        },
        {
          text: 'Tunisia',
          value: 'TN',
        },
        {
          text: 'Turkey',
          value: 'TR',
        },
        {
          text: 'Turkmenistan',
          value: 'TM',
        },
        {
          text: 'Turks and Caicos Islands',
          value: 'TC',
        },
        {
          text: 'Tuvalu',
          value: 'TV',
        },
        {
          text: 'Uganda',
          value: 'UG',
        },
        {
          text: 'Ukraine',
          value: 'UA',
        },
        {
          text: 'United Arab Emirates',
          value: 'AE',
        },
        {
          text: 'United Kingdom',
          value: 'GB',
        },
        {
          text: 'United States',
          value: 'US',
        },
        {
          text: 'United States Minor Outlying Islands',
          value: 'UM',
        },
        {
          text: 'Uruguay',
          value: 'UY',
        },
        {
          text: 'Uzbekistan',
          value: 'UZ',
        },
        {
          text: 'Vanuatu',
          value: 'VU',
        },
        {
          text: 'Venezuela, Bolivarian Republic of',
          value: 'VE',
        },
        {
          text: 'Viet Nam',
          value: 'VN',
        },
        {
          text: 'Virgin Islands, British',
          value: 'VG',
        },
        {
          text: 'Virgin Islands, U.S.',
          value: 'VI',
        },
        {
          text: 'Wallis and Futuna',
          value: 'WF',
        },
        {
          text: 'Western Sahara',
          value: 'EH',
        },
        {
          text: 'Yemen',
          value: 'YE',
        },
        {
          text: 'Zambia',
          value: 'ZM',
        },
        {
          text: 'Zimbabwe',
          value: 'ZW',
        },
      ],
      phoneCountryCodes: [{ text: 'Andorra(+376)', value: 376 }, { text: 'United Arab Emirates(+971)', value: 971 }, { text: 'Afghanistan(+93)', value: 93 }, { text: 'United States(+1)', value: 1 }, { text: 'United States(+1)', value: 1 }, { text: 'Albania(+355)', value: 355 }, { text: 'Armenia(+374)', value: 374 }, { text: 'Angola(+244)', value: 244 }, { text: 'Argentina(+54)', value: 54 }, { text: 'American Samoa(+1)', value: 1 }, { text: 'Austria(+43)', value: 43 }, { text: 'Australia(+61)', value: 61 }, { text: 'Aruba(+297)', value: 297 }, { text: 'Åland Islands(+358)', value: 358 }, { text: 'Azerbaijan(+994)', value: 994 }, { text: 'Bosnia and Herzegovina(+387)', value: 387 }, { text: 'Barbados(+1)', value: 1 }, { text: 'Bangladesh(+880)', value: 880 }, { text: 'Belgium(+32)', value: 32 }, { text: 'Burkina Faso(+226)', value: 226 }, { text: 'Bulgaria(+359)', value: 359 }, { text: 'Bahrain(+973)', value: 973 }, { text: 'Burundi(+257)', value: 257 }, { text: 'Benin(+229)', value: 229 }, { text: 'Saint Barthélemy(+590)', value: 590 }, { text: 'Bermuda(+1)', value: 1 }, { text: 'Brunei Darussalam(+673)', value: 673 }, { text: 'Bolivia, Plurinational State of(+591)', value: 591 }, { text: 'Bonaire, Sint Eustatius and Saba(+599)', value: 599 }, { text: 'Brazil(+55)', value: 55 }, { text: 'Bahamas(+1)', value: 1 }, { text: 'Bhutan(+975)', value: 975 }, { text: 'Botswana(+267)', value: 267 }, { text: 'Belarus(+375)', value: 375 }, { text: 'Belize(+501)', value: 501 }, { text: 'Canada(+1)', value: 1 }, { text: 'Congo, the Democratic Republic of the(+243)', value: 243 }, { text: 'Central African Republic(+236)', value: 236 }, { text: 'Congo(+242)', value: 242 }, { text: 'Switzerland(+41)', value: 41 }, { text: 'Côte d\'Ivoire(+225)', value: 225 }, { text: 'Cook Islands(+682)', value: 682 }, { text: 'Chile(+56)', value: 56 }, { text: 'Cameroon(+237)', value: 237 }, { text: 'China(+86)', value: 86 }, { text: 'Colombia(+57)', value: 57 }, { text: 'Costa Rica(+506)', value: 506 }, { text: 'Cuba(+53)', value: 53 }, { text: 'Cape Verde(+238)', value: 238 }, { text: 'Curaçao(+599)', value: 599 }, { text: 'Cyprus(+357)', value: 357 }, { text: 'Czech Republic(+420)', value: 420 }, { text: 'Germany(+49)', value: 49 }, { text: 'Djibouti(+253)', value: 253 }, { text: 'Denmark(+45)', value: 45 }, { text: 'Dominica(+1)', value: 1 }, { text: 'Dominican Republic(+1)', value: 1 }, { text: 'Algeria(+213)', value: 213 }, { text: 'Ecuador(+593)', value: 593 }, { text: 'Estonia(+372)', value: 372 }, { text: 'Egypt(+20)', value: 20 }, { text: 'Western Sahara(+212)', value: 212 }, { text: 'Eritrea(+291)', value: 291 }, { text: 'Spain(+34)', value: 34 }, { text: 'Ethiopia(+251)', value: 251 }, { text: 'Finland(+358)', value: 358 }, { text: 'Fiji(+679)', value: 679 }, { text: 'Falkland Islands (Malvinas)(+500)', value: 500 }, { text: 'Micronesia, Federated States of(+691)', value: 691 }, { text: 'Faroe Islands(+298)', value: 298 }, { text: 'France(+33)', value: 33 }, { text: 'Gabon(+241)', value: 241 }, { text: 'United Kingdom(+44)', value: 44 }, { text: 'Grenada(+1)', value: 1 }, { text: 'Georgia(+995)', value: 995 }, { text: 'French Guiana(+594)', value: 594 }, { text: 'Guernsey(+44)', value: 44 }, { text: 'Ghana(+233)', value: 233 }, { text: 'Gibraltar(+350)', value: 350 }, { text: 'Greenland(+299)', value: 299 }, { text: 'Gambia(+220)', value: 220 }, { text: 'Guinea(+224)', value: 224 }, { text: 'Guadeloupe(+590)', value: 590 }, { text: 'Equatorial Guinea(+240)', value: 240 }, { text: 'Greece(+30)', value: 30 }, { text: 'Guatemala(+502)', value: 502 }, { text: 'Guam(+1)', value: 1 }, { text: 'Guinea-Bissau(+245)', value: 245 }, { text: 'Guyana(+592)', value: 592 }, { text: 'Hong Kong(+852)', value: 852 }, { text: 'Honduras(+504)', value: 504 }, { text: 'Croatia(+385)', value: 385 }, { text: 'Haiti(+509)', value: 509 }, { text: 'Hungary(+36)', value: 36 }, { text: 'Indonesia(+62)', value: 62 }, { text: 'Ireland(+353)', value: 353 }, { text: 'Israel(+972)', value: 972 }, { text: 'Isle of Man(+44)', value: 44 }, { text: 'India(+91)', value: 91 }, { text: 'British Indian Ocean Territory(+246)', value: 246 }, { text: 'Iraq(+964)', value: 964 }, { text: 'Iran, Islamic Republic of(+98)', value: 98 }, { text: 'Iceland(+354)', value: 354 }, { text: 'Italy(+39)', value: 39 }, { text: 'Jersey(+44)', value: 44 }, { text: 'Jamaica(+1)', value: 1 }, { text: 'Jordan(+962)', value: 962 }, { text: 'Japan(+81)', value: 81 }, { text: 'Kenya(+254)', value: 254 }, { text: 'Kyrgyzstan(+996)', value: 996 }, { text: 'Cambodia(+855)', value: 855 }, { text: 'Kiribati(+686)', value: 686 }, { text: 'Comoros(+269)', value: 269 }, { text: 'Saint Kitts and Nevis(+1)', value: 1 }, { text: 'Korea, Democratic People\'s Republic of(+850)', value: 850 }, { text: 'Korea, Republic of(+82)', value: 82 }, { text: 'Kuwait(+965)', value: 965 }, { text: 'Cayman Islands(+1)', value: 1 }, { text: 'Kazakhstan(+7)', value: 7 }, { text: 'Lao People\'s Democratic Republic(+856)', value: 856 }, { text: 'Lebanon(+961)', value: 961 }, { text: 'Saint Lucia(+1)', value: 1 }, { text: 'Liechtenstein(+423)', value: 423 }, { text: 'Sri Lanka(+94)', value: 94 }, { text: 'Liberia(+231)', value: 231 }, { text: 'Lesotho(+266)', value: 266 }, { text: 'Lithuania(+370)', value: 370 }, { text: 'Luxembourg(+352)', value: 352 }, { text: 'Latvia(+371)', value: 371 }, { text: 'Libya(+218)', value: 218 }, { text: 'Morocco(+212)', value: 212 }, { text: 'Monaco(+377)', value: 377 }, { text: 'Moldova, Republic of(+373)', value: 373 }, { text: 'Montenegro(+382)', value: 382 }, { text: 'Saint Martin (French part)(+590)', value: 590 }, { text: 'Madagascar(+261)', value: 261 }, { text: 'Marshall Islands(+692)', value: 692 }, { text: 'Macedonia, the Former Yugoslav Republic of(+389)', value: 389 }, { text: 'Mali(+223)', value: 223 }, { text: 'Myanmar(+95)', value: 95 }, { text: 'Mongolia(+976)', value: 976 }, { text: 'Macao(+853)', value: 853 }, { text: 'Northern Mariana Islands(+1)', value: 1 }, { text: 'Martinique(+596)', value: 596 }, { text: 'Mauritania(+222)', value: 222 }, { text: 'Montserrat(+1)', value: 1 }, { text: 'Malta(+356)', value: 356 }, { text: 'Mauritius(+230)', value: 230 }, { text: 'Maldives(+960)', value: 960 }, { text: 'Malawi(+265)', value: 265 }, { text: 'Mexico(+52)', value: 52 }, { text: 'Malaysia(+60)', value: 60 }, { text: 'Mozambique(+258)', value: 258 }, { text: 'Namibia(+264)', value: 264 }, { text: 'New Caledonia(+687)', value: 687 }, { text: 'Niger(+227)', value: 227 }, { text: 'Norfolk Island(+672)', value: 672 }, { text: 'Nigeria(+234)', value: 234 }, { text: 'Nicaragua(+505)', value: 505 }, { text: 'Netherlands(+31)', value: 31 }, { text: 'Norway(+47)', value: 47 }, { text: 'Nepal(+977)', value: 977 }, { text: 'Nauru(+674)', value: 674 }, { text: 'Niue(+683)', value: 683 }, { text: 'New Zealand(+64)', value: 64 }, { text: 'Oman(+968)', value: 968 }, { text: 'Panama(+507)', value: 507 }, { text: 'Peru(+51)', value: 51 }, { text: 'French Polynesia(+689)', value: 689 }, { text: 'Papua New Guinea(+675)', value: 675 }, { text: 'Philippines(+63)', value: 63 }, { text: 'Pakistan(+92)', value: 92 }, { text: 'Poland(+48)', value: 48 }, { text: 'Saint Pierre and Miquelon(+508)', value: 508 }, { text: 'Puerto Rico(+1)', value: 1 }, { text: 'Palestine, State of(+970)', value: 970 }, { text: 'Portugal(+351)', value: 351 }, { text: 'Palau(+680)', value: 680 }, { text: 'Paraguay(+595)', value: 595 }, { text: 'Qatar(+974)', value: 974 }, { text: 'Réunion(+262)', value: 262 }, { text: 'Romania(+40)', value: 40 }, { text: 'Serbia(+381)', value: 381 }, { text: 'Russian Federation(+7)', value: 7 }, { text: 'Rwanda(+250)', value: 250 }, { text: 'Saudi Arabia(+966)', value: 966 }, { text: 'Solomon Islands(+677)', value: 677 }, { text: 'Seychelles(+248)', value: 248 }, { text: 'Sudan(+249)', value: 249 }, { text: 'Sweden(+46)', value: 46 }, { text: 'Singapore(+65)', value: 65 }, { text: 'Saint Helena, Ascension and Tristan da Cunha(+290)', value: 290 }, { text: 'Slovenia(+386)', value: 386 }, { text: 'Svalbard and Jan Mayen(+47)', value: 47 }, { text: 'Slovakia(+421)', value: 421 }, { text: 'Sierra Leone(+232)', value: 232 }, { text: 'San Marino(+378)', value: 378 }, { text: 'Senegal(+221)', value: 221 }, { text: 'Somalia(+252)', value: 252 }, { text: 'Suriname(+597)', value: 597 }, { text: 'South Sudan(+211)', value: 211 }, { text: 'Sao Tome and Principe(+239)', value: 239 }, { text: 'El Salvador(+503)', value: 503 }, { text: 'Sint Maarten (Dutch part)(+1)', value: 1 }, { text: 'Syrian Arab Republic(+963)', value: 963 }, { text: 'Swaziland(+268)', value: 268 }, { text: 'Turks and Caicos Islands(+1)', value: 1 }, { text: 'Chad(+235)', value: 235 }, { text: 'Togo(+228)', value: 228 }, { text: 'Thailand(+66)', value: 66 }, { text: 'Tajikistan(+992)', value: 992 }, { text: 'Tokelau(+690)', value: 690 }, { text: 'Timor-Leste(+670)', value: 670 }, { text: 'Turkmenistan(+993)', value: 993 }, { text: 'Tunisia(+216)', value: 216 }, { text: 'Tonga(+676)', value: 676 }, { text: 'Turkey(+90)', value: 90 }, { text: 'Trinidad and Tobago(+1)', value: 1 }, { text: 'Tuvalu(+688)', value: 688 }, { text: 'Taiwan, Province of China(+886)', value: 886 }, { text: 'Tanzania, United Republic of(+255)', value: 255 }, { text: 'Ukraine(+380)', value: 380 }, { text: 'Uganda(+256)', value: 256 }, { text: 'United States(+1)', value: 1 }, { text: 'Uruguay(+598)', value: 598 }, { text: 'Uzbekistan(+998)', value: 998 }, { text: 'Holy See (Vatican City State)(+39)', value: 39 }, { text: 'Saint Vincent and the Grenadines(+1)', value: 1 }, { text: 'Venezuela, Bolivarian Republic of(+58)', value: 58 }, { text: 'Virgin Islands, British(+1)', value: 1 }, { text: 'Virgin Islands, U.S.(+1)', value: 1 }, { text: 'Viet Nam(+84)', value: 84 }, { text: 'Vanuatu(+678)', value: 678 }, { text: 'Wallis and Futuna(+681)', value: 681 }, { text: 'Samoa(+685)', value: 685 }, { text: 'Yemen(+967)', value: 967 }, { text: 'Mayotte(+262)', value: 262 }, { text: 'South Africa(+27)', value: 27 }, { text: 'Zambia(+260)', value: 260 }, { text: 'Zimbabwe(+263)', value: 263 }],
    };
  },
  props: ['setNewProfile', 'defaultEmail', 'emailLock', 'countryLock', 'defaultCountry', 'defaultPhoneCountryCode'],
  methods: {
    getProfileData() {
      if (this.country === 'SG') {
        this.city = 'Singapore';
        this.state = 'Singapore';
      }

      const profileData = {
        first_name: this.firstName,
        last_name: this.lastName,
        email: this.email,
        company_name: this.companyName,
        address1: this.address1,
        address2: this.address2,
        city: this.city,
        state: this.state,
        country: this.country,
        postal_code: this.postalCode,
        phone_country_code: this.phoneCountryCode,
        phone: this.phone,
        fax_country_code: this.faxCountryCode,
        fax: this.fax,
      };

      localStorage.setItem('DomainRegistrantCache', JSON.stringify(profileData));

      return profileData;
    },
  },
  created() {
    if (this.emailLock) {
      this.emailDisabled = true;
    }

    if (this.countryLock) {
      this.countryDisabled = true;
    }

    if (typeof this !== 'undefined' && typeof this.setNewProfile !== 'undefined' && this.setNewProfile !== null) {
      this.firstName = this.setNewProfile.first_name;
      this.lastName = this.setNewProfile.last_name;
      this.companyName = this.setNewProfile.company_name;
      this.email = this.setNewProfile.email;
      this.address1 = this.setNewProfile.address1;
      this.address2 = this.setNewProfile.address2;
      this.city = this.setNewProfile.city;
      this.state = this.setNewProfile.state;
      this.country = this.setNewProfile.country;
      this.postalCode = this.setNewProfile.postal_code;
      this.phoneCountryCode = this.setNewProfile.phone_country_code * 1;
      this.phone = this.setNewProfile.phone;
      this.faxCountryCode = this.setNewProfile.fax_country_code > 0
        ? this.setNewProfile.fax_country_code * 1 : null;
      this.fax = this.setNewProfile.fax;
    }
  },
  watch: {
    setNewProfile: {
      handler(setNewProfile) {
        if (setNewProfile) {
          this.firstName = setNewProfile.first_name;
          this.lastName = setNewProfile.last_name;
          this.companyName = setNewProfile.company_name;
          this.email = setNewProfile.email;
          this.address1 = setNewProfile.address1;
          this.address2 = setNewProfile.address2;
          this.city = setNewProfile.city;
          this.state = setNewProfile.state;
          this.country = setNewProfile.country;
          this.postalCode = setNewProfile.postal_code;
          this.phoneCountryCode = setNewProfile.phone_country_code * 1;
          this.phone = setNewProfile.phone;
          this.faxCountryCode = setNewProfile.fax_country_code > 0
            ? setNewProfile.fax_country_code * 1 : null;
          this.fax = setNewProfile.fax;
        } else {
          this.firstName = '';
          this.lastName = '';
          this.companyName = '';
          this.email = '';
          this.address1 = '';
          this.address2 = '';
          this.city = '';
          this.state = '';
          this.country = '';
          this.postalCode = '';
          this.phoneCountryCode = '';
          this.phone = '';
          this.faxCountryCode = '';
          this.fax = '';
        }
      },
      deep: true,
    },
    defaultEmail: {
      handler(defaultEmail) {
        this.email = defaultEmail;
      },
    },
    defaultCountry: {
      handler(defaultCountry) {
        this.country = defaultCountry;
      },
    },
    defaultPhoneCountryCode: {
      handler(defaultPhoneCountryCode) {
        this.phoneCountryCode = defaultPhoneCountryCode;
        console.log(this.phoneCountryCode);
      },
    },
  },
};
</script>

<style scoped>

</style>
